import { render } from "./DisputesSidebar.vue?vue&type=template&id=68bc7244&ts=true"
import script from "./DisputesSidebar.vue?vue&type=script&lang=ts"
export * from "./DisputesSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__